import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Input } from "antd";
export default function CustomAttributesEditor({ value = {}, onChange }) {
  const entries = Object.entries(value || {});
  const update = (idx, key, val) => {
    if (!String(key).trim()) return;
    const next = { ...value };
    const old = entries[idx]?.[0];
    if (old && old !== key) delete next[old];
    if (key) next[key] = val;
    onChange?.(next);
  };
  return (
    <div>
      {entries.map(([k, v], i) => (
        <div key={`${k}-${i}`} className="specstudio-attribute-row">
          <Input
            value={k}
            placeholder="Tên thông số, VD: Số mũi thêu tối đa"
            onChange={(e) => update(i, e.target.value, v)}
          />
          <Input
            value={String(v)}
            placeholder="Giá trị, VD: 15,000 stitches"
            onChange={(e) => update(i, k, e.target.value)}
          />
          <Button
            icon={<DeleteOutlined />}
            onClick={() => {
              const n = { ...value };
              delete n[k];
              onChange?.(n);
            }}
          />
        </div>
      ))}
      <Button
        type="dashed"
        icon={<PlusOutlined />}
        onClick={() =>
          onChange?.({ ...value, [`attribute_${Date.now()}`]: "" })
        }
      >
        Thêm thông số tùy chỉnh
      </Button>
    </div>
  );
}
